import React, { useEffect, useRef, useState } from 'react';
import './App.css';

function Contacto() {
  useEffect(() => { document.title = 'Contacto'; }, []);
  const formRef = useRef(null);
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const [error, setError] = useState(null);
  //Campos del Formulario
  const [nameForm, setNameForm] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    const form = formRef.current;
    if (!form.checkValidity()) {
      form.classList.add('was-validated');
      return;
    }
    setEnviando(true);
    const formData = new FormData(form);
    try {
      const response = await fetch('https://leads.getmarket.mx/api/em6622/', {
        method: 'POST',
        body: formData
      });
      if (response.ok) {
        setEnviado(true);
        form.reset();
        form.classList.remove('was-validated');
      } else {
        setError('Hubo un error al enviar el formulario. Intenta de nuevo.');
      }
    } catch (err) {
      setError('Hubo un error al enviar el formulario. Intenta de nuevo.');
    }
    setEnviando(false);
  };

  return (
    <section className="first-section-padding section-bottom-border">
      <div className="container">
        <div className="row align-items-center">
          {/* Columna de imagen */}
          <div className="col-lg-4 text-center mb-4 mb-md-0">
            <img src={process.env.PUBLIC_URL + '/contacto/contacto.webp'} alt="Contacto" style={{width: '100%', maxWidth: '340px', borderRadius: '32px'}} />
          </div>
          {/* Columna de formulario */}
          <div className="col-lg-8">
            <h1 className="title-contacto" >Contáctanos</h1>
            <form id="myform" className="needs-validation" noValidate ref={formRef} onSubmit={handleSubmit}>
              <input type="hidden" name="page" value="OpticaParis"  onChange={(e) => setNameForm(e.target.value)}></input>
              <div className="mb-3">
            
                <input type="text" name="first_name" id="first_name" value={firstName} onChange={(e) => setFirstName(e.target.value)}  className="form-control border-0 border-bottom rounded-0" placeholder="Nombre" style={{fontSize: '1.1rem', background: 'transparent'}} required />
                <div className="invalid-feedback text-start">Por favor ingresa tu nombre.</div>
              </div>
              <input type="hidden" name="last_name" value="-" onChange={(e) => setLastName(e.target.value)}  className="form-control" id="last_name"></input>
              <div className="mb-3">
                {/*<input 
            type="email" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)} 
          /> */}
                <input type="email" name="email" id="email" value={email} onChange={(e) => setEmail(e.target.value)} className="form-control border-0 border-bottom rounded-0" placeholder="Correo" style={{fontSize: '1.1rem', background: 'transparent'}} required />
                <div className="invalid-feedback text-start">Por favor ingresa un correo válido.</div>
              </div>
              <div className="mb-3">
                <input type="tel" name="phone" id="phone" value={phone} onChange={(e) => setPhone(e.target.value)} className="form-control border-0 border-bottom rounded-0" placeholder="Celular *10 dígitos" style={{fontSize: '1.1rem', background: 'transparent'}} pattern="[0-9]{10}" required />
                <div className="invalid-feedback text-start">Por favor ingresa un celular válido de 10 dígitos.</div>
              </div>
              <div className="mb-4">
                <textarea name="message" id="message" value={message} onChange={(e) => setMessage(e.target.value)} className="form-control border-0 border-bottom rounded-0" placeholder="Mensaje" rows="2" style={{fontSize: '1.1rem', background: 'transparent', resize: 'none'}} required></textarea>
                <div className="invalid-feedback text-start">Por favor ingresa tu mensaje.</div>
              </div>
              <div className="form-check mb-4">
                <input className="form-check-input" type="checkbox" id="acepto" name="acepto" required />
                <label className="form-check-label" htmlFor="acepto">
                  Estoy de acuerdo en recibir información sobre los servicios que ofrecen. Acepto los términos.
                </label>
                <div className="invalid-feedback text-start">Debes aceptar los términos para continuar.</div>
              </div>
              <div className="text-start">
                <button style={{fontWeight:'700'}} type="submit" id="sbmtBtn" className="btn btn-contacto" disabled={enviando}>{enviando ? 'Enviando...' : 'ENVIAR'}</button>
              </div>
              {enviado && <div className="alert alert-success mt-3">¡Mensaje enviado correctamente!</div>}
              {error && <div className="alert alert-danger mt-3">{error}</div>}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contacto; 